import { c as _c } from "react/compiler-runtime";
interface ThoracicSurgeryIconProps {
  size?: number;
  className?: string;
}
const ThoracicSurgeryIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M10.3107 11.8391C9.93263 11.9447 9.62125 12.2394 9.42109 12.5786C9.22092 12.9177 9.10972 13.3014 9.00963 13.6851C8.90955 14.0687 8.81503 14.4524 8.64266 14.8082C8.48698 15.1251 8.27013 15.4032 8.10332 15.7145C7.93652 16.0259 7.81975 16.3817 7.88648 16.7265M9.87702 15.8146C9.87146 15.57 9.82142 15.3309 9.73246 15.1029C9.62125 14.8193 9.44889 14.5636 9.30988 14.2967C9.17088 14.0298 9.05412 13.7295 9.07636 13.4293M8.69826 14.6859C8.4981 14.7749 8.27569 14.7971 8.05884 14.8082C7.84199 14.8193 7.61959 14.8193 7.4083 14.8583C7.19145 14.8972 6.98017 14.9861 6.83004 15.1418M11.9009 10.0932C13.9526 10.0932 13.9526 5.47266 13.9526 5.47266M20.1189 16.7265C20.1856 16.3817 20.0688 16.0259 19.902 15.7145C19.7352 15.4032 19.5184 15.1251 19.3627 14.8082C19.1903 14.4524 19.0958 14.0687 18.9957 13.6851C18.8956 13.3014 18.7844 12.9177 18.5843 12.5786C18.3841 12.2394 18.0783 11.9447 17.6946 11.8391M18.9235 13.4293C18.9457 13.7351 18.8345 14.0298 18.6899 14.2967C18.5509 14.5636 18.3786 14.8193 18.2673 15.1029C18.1784 15.3309 18.1283 15.57 18.1228 15.8146M21.1753 15.1418C21.0252 14.9806 20.8139 14.8972 20.5971 14.8583C20.3802 14.8193 20.1634 14.8193 19.9465 14.8082C19.7297 14.7971 19.5073 14.7749 19.3071 14.6859M14.0472 5.47266C14.0472 5.47266 14.0472 10.0932 16.0989 10.0932M12.2067 12.5563V16.5208C12.2067 17.9164 11.4339 19.2008 10.1995 19.8569L7.73079 21.1635C6.11278 22.0198 4.21119 20.6631 4.50032 18.856C5.02298 15.57 6.14614 11.1941 8.53702 8.83101C9.47113 7.90246 11.0558 8.15823 11.6174 9.35367C12.0566 10.2933 12.2123 11.3498 12.2123 12.5619L12.2067 12.5563ZM15.7931 12.5563V16.5208C15.7931 17.9164 16.5659 19.2008 17.8003 19.8569L20.269 21.1635C21.887 22.0198 23.7886 20.6631 23.4995 18.856C22.9768 15.57 21.8537 11.1941 19.4628 8.83101C18.5287 7.90246 16.944 8.15823 16.3824 9.35367C15.9432 10.2933 15.7875 11.3498 15.7875 12.5619L15.7931 12.5563Z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== t3 || $[4] !== t5) {
    t7 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}</svg>;
    $[3] = t3;
    $[4] = t5;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
};
export default ThoracicSurgeryIcon;